export default {
  // 列表页面
  pageTitle: '陆空一体协同巡检任务',
  taskName: '任务名称',
  wayLineJobId: '航线作业ID',
  dogTaskId: '机器狗任务ID',
  createTime: '创建时间',
  operation: '操作',
  viewReport: '查看报告',
  fetchTaskListFailed: '获取任务列表失败',

  // 详情页面
  detailTitle: '陆空一体协同巡检报告',
  breadcrumbInspection: '协同巡检',
  breadcrumbReport: '报告',

  // 卡片标题
  section1Title: '一、统计概览',
  section2Title: '二、机器狗巡检任务',
  section3Title: '三、无人机巡检任务',
  section4Title: '四、机器狗巡检内容与结果',
  section5Title: '五、无人机巡检内容与结果',
  section6Title: '六、综合结论',

  // 统计概览
  totalCount: '总检测数量',
  detectionTypes: '检测类型',
  abnormalHeatSourceCount: '异常热源数量',
  stackedObjectCount: '堆叠物数量',
  vehicleViolationCount: '车辆违停数量',
  unit: '个',
  unitType: '种',

  // 任务信息
  taskNameLabel: '任务名称',
  executionTime: '执行时间',

  // 表格列
  category: '检查大类',
  subItem: '检查子项',
  standard: '标准/要求',
  result: '检查结果',
  remarks: '发现的问题/建议',

  // 检查项
  stackedObject: '堆叠物',
  stackedObjectCheck: '通道及设备周围堆叠物检查',
  stackedObjectStandard: '通道及设备周围无堆叠物，保持畅通',
  abnormalHeatSource: '异常热源',
  smokeDetection: '烟雾检测',
  smokeDetectionStandard: '无烟雾，空气质量正常',
  fireDetection: '明火检测',
  fireDetectionStandard: '无明火，温度正常',
  vehicleViolation: '车辆违停',
  vehicleViolationCheck: '消防通道及禁停区域车辆检查',
  vehicleViolationStandard: '消防通道及禁停区域无违停车辆',

  // 检查结果
  qualified: '合格',
  unqualified: '不合格',
  attention: '注意',

  // 检查结果描述
  stackedObjectQualified: '未发现堆叠物，通道畅通，符合要求。',
  stackedObjectUnqualified: '检测到堆叠物{count}处，建议及时清理，保持通道畅通。',
  smokeQualified: '未发现烟雾，符合要求。',
  smokeUnqualified: '检测到烟雾{count}处，建议立即排查烟雾来源，确保安全。',
  fireQualified: '未发现明火，符合要求。',
  fireUnqualified: '检测到明火{count}处，建议立即处理，确保安全。',
  vehicleViolationQualified: '未发现车辆违停，停车场管理规范，符合要求。',
  vehicleViolationUnqualified: '检测到车辆违停{count}处，建议联系车主移车，保持消防通道畅通。',

  // 告警
  dogAlarmDetails: '机器狗告警详情',
  flightAlarmDetails: '无人机告警详情',
  totalAlarms: '共 {count} 条告警',
  alarmType: '告警类型',
  alarmDetail: '详细信息',
  position: '位置坐标',
  detectionTime: '检测时间',
  sceneImage: '现场图片',

  // 告警类型
  alarmFire: '异常热源',
  alarmSmoke: '烟雾',
  alarmBox: '堆叠物',
  alarmMeter: '电表读数',
  alarmViolation: '车辆违停',

  // 空状态
  dogInspectionNoIssue: '机器狗巡检完成，未发现异常',
  flightInspectionNoIssue: '无人机巡检完成，未发现异常',

  // 综合结论
  conclusionHasIssues: '本次陆空一体协同巡检发现以下问题：',
  conclusionNoIssue: '本次陆空一体协同巡检整体情况良好，未发现异常情况，各项检查指标均符合要求。',
  unqualifiedItem: '{count}项不合格项',
  riskPoint: '{count}个风险点',
  alarmItem: '{count}条告警',
  conclusionSuggestion: '。请按整改建议及时落实整改措施，并跟踪整改进度。',

  // 错误信息
  missingParameters: '缺少必要参数',
  fetchReportFailed: '获取报告数据失败',
  fetchDogAlarmFailed: '获取机器狗告警数据失败',
  fetchFlightAlarmFailed: '获取无人机告警数据失败',
}
